(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

var PresentUtils_1 = __webpack_require__(2);
var Node = function () {
    function Node() {
        this._states = {};
        this._final = false;
        this._id = Node.nextId++;
    }
    Object.defineProperty(Node.prototype, "id", {
        get: function get() {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "states", {
        get: function get() {
            return this._states;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "final", {
        get: function get() {
            return this._final;
        },
        set: function set(value) {
            this._final = value;
        },
        enumerable: true,
        configurable: true
    });
    Node.prototype.nodeOf = function (character) {
        return this._states[character];
    };
    Node.prototype.addState = function (node, character) {
        PresentUtils_1.throwIfAbsent(node, 'node');
        PresentUtils_1.throwIfAbsent(character, 'character');
        this._states[character] = node;
    };
    Node.prototype.equals = function (node) {
        if (this.final !== node.final || Object.keys(this.states).length !== Object.keys(node.states).length) {
            return false;
        }
        return this.equalRightLanguage(node);
    };
    Node.prototype.equalRightLanguage = function (node) {
        if (this.shallowSize() !== node.shallowSize()) {
            return false;
        }
        for (var _i = 0, _a = Object.keys(this.states); _i < _a.length; _i++) {
            var key = _a[_i];
            var subNode = this.nodeOf(key);
            var testNode = node.nodeOf(key);
            var equal = testNode && testNode.equals(subNode);
            if (!equal) {
                return false;
            }
        }
        return true;
    };
    Node.prototype.signatureToString = function () {
        var rightLanguage = this.final ? '1' : '0';
        for (var _i = 0, _a = Object.keys(this.states).sort(); _i < _a.length; _i++) {
            var key = _a[_i];
            rightLanguage += "" + key + this.nodeOf(key).id;
        }
        return rightLanguage;
    };
    Node.prototype.shallowSize = function () {
        return Object.keys(this.states).length;
    };
    Node.prototype.size = function () {
        return this.count();
    };
    Node.prototype.count = function (countedNodes) {
        if (countedNodes === void 0) {
            countedNodes = new Set();
        }
        if (!countedNodes.has(this.signatureToString())) {
            countedNodes.add(this.signatureToString());
            var size = 1;
            for (var _i = 0, _a = Object.keys(this.states); _i < _a.length; _i++) {
                var key = _a[_i];
                size += this.nodeOf(key).count(countedNodes);
            }
            return size;
        }
        return 0;
    };
    Node.nextId = 0;
    return Node;
}();
exports.Node = Node;

/***/ },
/* 1 */
/***/ function(module, exports) {

"use strict";
"use strict";

var Predicates = function () {
    function Predicates() {}
    Predicates.endsWith = function () {
        var suffixes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            suffixes[_i - 0] = arguments[_i];
        }
        return function (node, char, word) {
            return suffixes.some(function (suffix) {
                return word.endsWith(suffix);
            });
        };
    };
    Predicates.containsAny = function () {
        var strings = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            strings[_i - 0] = arguments[_i];
        }
        return function (node, char, word) {
            return strings.some(function (expression) {
                return RegExp(expression).test(word);
            });
        };
    };
    Predicates.containsAll = function () {
        var strings = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            strings[_i - 0] = arguments[_i];
        }
        return function (node, char, word) {
            return strings.every(function (expression) {
                return RegExp(expression).test(word);
            });
        };
    };
    Predicates.containsOnly = function () {
        var strings = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            strings[_i - 0] = arguments[_i];
        }
        var expression = RegExp("^((" + strings.join(')|(') + "))*$"); // Will return a regexp like so: /^((火)|(日)|(木))*$/
        return function (node, char, word) {
            return expression.test(word);
        };
    };
    Predicates.exclude = function () {
        var strings = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            strings[_i - 0] = arguments[_i];
        }
        return function (node, char, word) {
            return !Predicates.containsAny.apply(Predicates, strings)(node, char, word);
        };
    };
    Predicates.maxLength = function (length) {
        return function (node, char, word) {
            return word.length <= length;
        };
    };
    Predicates.minLength = function (length) {
        return function (node, char, word) {
            return word.length >= length;
        };
    };
    return Predicates;
}();
exports.Predicates = Predicates;

/***/ },
/* 2 */
/***/ function(module, exports) {

"use strict";
"use strict";

function throwIfAbsent(value, name, error) {
    if (!isPresent(value)) {
        throw error ? error : new Error("Error: " + name + " was not given.");
    }
}
exports.throwIfAbsent = throwIfAbsent;
function isPresent(value) {
    return value !== undefined && value !== null;
}
exports.isPresent = isPresent;

/***/ },
/* 3 */
/***/ function(module, exports) {

"use strict";
"use strict";

function editDistance(node, word, options) {
    if (options === void 0) {
        options = { maxDistance: 3, maxResults: Number.MAX_VALUE };
    }
    return searchForSimilarWords(node, word, options);
}
exports.editDistance = editDistance;
function searchForSimilarWords(node, word, options, comparedWord, table) {
    if (options === void 0) {
        options = { maxDistance: 3, maxResults: Number.MAX_VALUE };
    }
    if (comparedWord === void 0) {
        comparedWord = '';
    }
    if (table === void 0) {
        table = initializeEditDistanceMatrix(word.length);
    }
    var results = [];
    for (var _i = 0, _a = Object.keys(node.states); _i < _a.length; _i++) {
        var key = _a[_i];
        var currentWord = comparedWord + key;
        for (var wordIndex = 0; wordIndex <= word.length; wordIndex++) {
            var currentWordIndex = currentWord.length;
            table[wordIndex][currentWordIndex] = editDistanceOf({
                wordIndex: wordIndex,
                currentWordIndex: currentWordIndex,
                word: word,
                comparedWord: currentWord,
                table: table
            });
        }
        var editDistanceValue = table[word.length][currentWord.length];
        if (node.nodeOf(key).final && editDistanceValue <= options.maxDistance) {
            results.push(currentWord);
        }
        if (results.length >= options.maxResults) {
            return results.slice(0, options.maxResults);
        }
        results = results.concat(searchForSimilarWords(node.nodeOf(key), word, options, currentWord, table));
    }
    return results.slice(0, options.maxResults);
}
function editDistanceOf(data) {
    var table = data.table;
    var firstIndex = data.wordIndex;
    var secondIndex = data.currentWordIndex;
    if (Math.min(firstIndex, secondIndex) === 0) {
        return Math.max(firstIndex, secondIndex);
    }
    var inequalityPunishment = data.word[firstIndex - 1] === data.comparedWord[secondIndex - 1] ? 0 : 1;
    return Math.min(table[firstIndex][secondIndex - 1] + 1, table[firstIndex - 1][secondIndex] + 1, table[firstIndex - 1][secondIndex - 1] + inequalityPunishment);
}
function initializeEditDistanceMatrix(len) {
    var matrix = [];
    for (var index = 0; index <= len; index++) {
        matrix[index] = [index];
    }
    return matrix;
}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

var Node_1 = __webpack_require__(0);
var Predicates_1 = __webpack_require__(1);
var PresentUtils_1 = __webpack_require__(2);
var editDistance_1 = __webpack_require__(3);
var WordGraph = function () {
    function WordGraph() {
        this._root = new Node_1.Node();
    }
    Object.defineProperty(WordGraph.prototype, "root", {
        get: function get() {
            return this._root;
        },
        enumerable: true,
        configurable: true
    });
    WordGraph.prototype.add = function (word) {
        PresentUtils_1.throwIfAbsent(word, 'word');
    };
    WordGraph.prototype.lookup = function (word) {
        var node = this.climbTo(word);
        return node ? node.final : false;
    };
    WordGraph.prototype.startsWith = function (prefix) {
        var predicates = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            predicates[_i - 1] = arguments[_i];
        }
        var node = this.climbTo(prefix);
        if (!node) {
            return [];
        }
        var words = [];
        if (this.wordShouldBeAdded(node, predicates, prefix[prefix.length - 1], prefix)) {
            words.push(prefix);
        }
        return words.concat(this.getWord.apply(this, [node, prefix, false].concat(predicates)));
    };
    WordGraph.prototype.endsWith = function (suffix) {
        return this.getWord(this.root, '', false, Predicates_1.Predicates.endsWith(suffix));
    };
    WordGraph.prototype.containsAny = function (strings) {
        return this.getWord(this.root, '', false, Predicates_1.Predicates.containsAny.apply(Predicates_1.Predicates, strings));
    };
    WordGraph.prototype.containsAll = function (strings) {
        return this.getWord(this.root, '', false, Predicates_1.Predicates.containsAll.apply(Predicates_1.Predicates, strings));
    };
    WordGraph.prototype.containsOnly = function (strings) {
        var words = [];
        var regexp = RegExp("^(" + strings.join('|') + ")*$"); // Will produce a regexp like : ^(david|was|here)*$
        for (var _i = 0, strings_1 = strings; _i < strings_1.length; _i++) {
            var subString = strings_1[_i];
            var node = this.climbTo(subString);
            if (node) {
                words = words.concat(this.getWord(node, subString, true, function (node, char, word) {
                    return regexp.test(word);
                }));
            }
        }
        return words;
    };
    WordGraph.prototype.getWord = function (node, prefix, exitIfPredicateFail) {
        var _this = this;
        if (prefix === void 0) {
            prefix = '';
        }
        if (exitIfPredicateFail === void 0) {
            exitIfPredicateFail = false;
        }
        var predicates = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            predicates[_i - 3] = arguments[_i];
        }
        var words = [];
        Object.keys(node.states).forEach(function (char) {
            var subNode = node.states[char];
            var wordSoFar = prefix + char;
            if (_this.wordShouldBeAdded(subNode, predicates, char, wordSoFar)) {
                words.push(wordSoFar);
                words = words.concat(_this.getWord.apply(_this, [subNode, wordSoFar, exitIfPredicateFail].concat(predicates)));
            } else if (!subNode.final || subNode.final && !exitIfPredicateFail) {
                words = words.concat(_this.getWord.apply(_this, [subNode, wordSoFar, exitIfPredicateFail].concat(predicates)));
            }
        });
        return words;
    };
    WordGraph.prototype.similarTo = function (word, options) {
        if (options === void 0) {
            options = { maxDistance: 3, maxResults: Number.MAX_VALUE };
        }
        return editDistance_1.editDistance(this.root, word, options);
    };
    WordGraph.prototype.size = function () {
        return this.root.size();
    };
    WordGraph.prototype.climbTo = function (prefix) {
        var node = this.root;
        for (var _i = 0, prefix_1 = prefix; _i < prefix_1.length; _i++) {
            var char = prefix_1[_i];
            node = node.nodeOf(char);
            if (!node) {
                return null;
            }
        }
        return node;
    };
    WordGraph.prototype.wordShouldBeAdded = function (subNode, predicates, char, word) {
        return subNode.final && predicates.every(function (predicate) {
            return predicate(subNode, char, word);
        });
    };
    return WordGraph;
}();
exports.WordGraph = WordGraph;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

var MinimalWordGraph_1 = __webpack_require__(6);
exports.MinimalWordGraph = MinimalWordGraph_1.MinimalWordGraph;
var Trie_1 = __webpack_require__(8);
exports.Trie = Trie_1.Trie;
var QueryBuilder_1 = __webpack_require__(7);
exports.QueryBuilder = QueryBuilder_1.QueryBuilder;
var editDistance_1 = __webpack_require__(3);
exports.editDistance = editDistance_1.editDistance;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

var __extends = undefined && undefined.__extends || function (d, b) {
    for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
    }function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var WordGraph_1 = __webpack_require__(4);
var Node_1 = __webpack_require__(0);
var MinimalWordGraph = function (_super) {
    __extends(MinimalWordGraph, _super);
    function MinimalWordGraph() {
        _super.apply(this, arguments);
        this.lastWordAdded = '';
        this.registry = {};
    }
    MinimalWordGraph.prototype.add = function (word) {
        _super.prototype.add.call(this, word);
        if (this.isImmutable()) {
            throw 'This MinimalWordGraph(DAWG) is immutable and words may no longer be added to it.';
        }
        if (word < this.lastWordAdded) {
            throw "Words need to be added in lexicographical order. " + word + " after " + this.lastWordAdded;
        }
        var _a = this.climbUntilEmpty(word),
            node = _a.node,
            index = _a.index;
        if (index < this.lastWordAdded.length && this.lastWordAdded !== '') {
            var minimizedNode = this.minimize(node.nodeOf(this.lastWordAdded[index]), this.lastWordAdded.substr(index + 1));
            node.addState(minimizedNode, this.lastWordAdded[index]);
        }
        for (index; index < word.length; index++) {
            var newNode = new Node_1.Node();
            node.addState(newNode, word[index]);
            node = newNode;
        }
        node.final = true;
        this.lastWordAdded = word;
    };
    MinimalWordGraph.prototype.minimize = function (node, word) {
        if (word !== '') {
            var minimizedChild = this.minimize(node.nodeOf(word[0]), word.substr(1));
            node.addState(minimizedChild, word[0]);
        }
        var rightLanguage = node.signatureToString();
        var registeredNode = this.registry[rightLanguage];
        if (!registeredNode) {
            this.registry[rightLanguage] = node;
            registeredNode = node;
        }
        return registeredNode;
    };
    MinimalWordGraph.prototype.size = function () {
        return this.isImmutable() ? this.immutableSize : _super.prototype.size.call(this);
    };
    MinimalWordGraph.prototype.makeImmutable = function () {
        this.minimize(this.root, this.lastWordAdded);
        this.lastWordAdded = null;
        this.registry = null;
        this.immutableSize = _super.prototype.size.call(this);
    };
    MinimalWordGraph.prototype.isImmutable = function () {
        return this.registry === null;
    };
    MinimalWordGraph.prototype.climbUntilEmpty = function (word) {
        var node = this._root;
        var index = 0;
        for (index; index < word.length; index++) {
            var nextNode = node.nodeOf(word[index]);
            if (nextNode) {
                node = nextNode;
            } else {
                break;
            }
        }
        return { node: node, index: index };
    };
    return MinimalWordGraph;
}(WordGraph_1.WordGraph);
exports.MinimalWordGraph = MinimalWordGraph;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

var Predicates_1 = __webpack_require__(1);
var QueryBuilder = function () {
    function QueryBuilder(wordGraph) {
        this.startsWithPatterns = [];
        this.endsWithPatterns = [];
        this.containsAllPatterns = [];
        this.containsAnyPatterns = [];
        this.containsOnlyPatterns = [];
        this.excludePatterns = [];
        this.predicates = { userPredicates: [] };
        this.wordGraph = wordGraph;
    }
    ;
    QueryBuilder.prototype.startsWith = function () {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i - 0] = arguments[_i];
        }
        this.startsWithPatterns = this.startsWithPatterns.concat(patterns);
        return this;
    };
    QueryBuilder.prototype.endsWith = function () {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i - 0] = arguments[_i];
        }
        this.endsWithPatterns = this.endsWithPatterns.concat(patterns);
        this.predicates.endsWithPatterns = Predicates_1.Predicates.endsWith.apply(Predicates_1.Predicates, patterns);
        return this;
    };
    QueryBuilder.prototype.containsAll = function () {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i - 0] = arguments[_i];
        }
        this.containsAllPatterns = this.containsAllPatterns.concat(patterns);
        this.predicates.containsAll = Predicates_1.Predicates.containsAll.apply(Predicates_1.Predicates, patterns);
        return this;
    };
    QueryBuilder.prototype.containsAny = function () {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i - 0] = arguments[_i];
        }
        this.containsAnyPatterns = this.containsAnyPatterns.concat(patterns);
        this.predicates.containsAny = Predicates_1.Predicates.containsAny.apply(Predicates_1.Predicates, patterns);
        return this;
    };
    QueryBuilder.prototype.containsOnly = function () {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i - 0] = arguments[_i];
        }
        this.containsOnlyPatterns = this.containsOnlyPatterns.concat(patterns);
        this.predicates.containsOnly = Predicates_1.Predicates.containsOnly.apply(Predicates_1.Predicates, patterns);
        return this;
    };
    QueryBuilder.prototype.exclude = function () {
        var patterns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            patterns[_i - 0] = arguments[_i];
        }
        this.excludePatterns = this.excludePatterns.concat(patterns);
        this.predicates.exclude = Predicates_1.Predicates.exclude.apply(Predicates_1.Predicates, patterns);
        return this;
    };
    QueryBuilder.prototype.maxLength = function (length) {
        this.predicates.minLength = Predicates_1.Predicates.maxLength(length);
        return this;
    };
    QueryBuilder.prototype.minLength = function (length) {
        this.predicates.minLength = Predicates_1.Predicates.minLength(length);
        return this;
    };
    QueryBuilder.prototype.addPredicate = function (predicate) {
        this.predicates.userPredicates.push(predicate);
        return this;
    };
    QueryBuilder.prototype.build = function () {
        var _this = this;
        var predicates = this.createAndSortPredicates();
        if (this.startsWithPatterns.length === 0) {
            this.startsWithPatterns.push('');
        }
        return function () {
            var results = [];
            _this.startsWithPatterns.forEach(function (prefix) {
                return results = results.concat((_a = _this.wordGraph).startsWith.apply(_a, [prefix].concat(predicates)));var _a;
            });
            return results;
        };
    };
    QueryBuilder.prototype.createAndSortPredicates = function () {
        var predicates = this.predicates.userPredicates;
        delete this.predicates.userPredicates;
        for (var _i = 0, _a = Object.keys(this.predicates); _i < _a.length; _i++) {
            var key = _a[_i];
            predicates.push(this.predicates[key]);
        }
        predicates.sort(function (predicate) {
            return predicate.precidence;
        });
        return predicates;
    };
    return QueryBuilder;
}();
exports.QueryBuilder = QueryBuilder;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

var __extends = undefined && undefined.__extends || function (d, b) {
    for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
    }function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var WordGraph_1 = __webpack_require__(4);
var Node_1 = __webpack_require__(0);
var Trie = function (_super) {
    __extends(Trie, _super);
    function Trie() {
        _super.apply(this, arguments);
    }
    Trie.prototype.add = function (word) {
        _super.prototype.add.call(this, word);
        var node = this._root;
        for (var i = 0; i < word.length; i++) {
            var tempNode = node.nodeOf(word[i]);
            if (tempNode) {
                node = tempNode;
            } else {
                var nextNode = new Node_1.Node();
                node.addState(nextNode, word[i]);
                node = nextNode;
            }
        }
        node.final = true;
    };
    Trie.prototype.minimize = function () {
        this.minimizeFrom(this.root);
    };
    Trie.prototype.minimizeFrom = function (node, registry) {
        if (registry === void 0) {
            registry = [];
        }
        for (var _i = 0, _a = Object.keys(node.states); _i < _a.length; _i++) {
            var char = _a[_i];
            node.addState(this.minimizeFrom(node.nodeOf(char), registry), char);
        }
        var rightLanguage = node.signatureToString();
        var registeredNode = registry[rightLanguage];
        if (!registeredNode) {
            registry[rightLanguage] = node;
            registeredNode = node;
        }
        return registeredNode;
    };
    return Trie;
}(WordGraph_1.WordGraph);
exports.Trie = Trie;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";

function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
__export(__webpack_require__(5));

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// dist/main.js